import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import * as _ from "lodash";
import { FinanceUtilityService } from "src/app/finance/util/finance-utility.service";
import { DatePipe, TitleCasePipe } from "@angular/common";
import { PaymentmethodService } from "src/app/configurations/inventory/setup/paymentmethod/paymentmethod.service";
import { catchError, forkJoin, from, map, Subject, switchMap, takeUntil } from "rxjs";
import { CustomAttributeFieldType, SOChannel } from "src/app/inventory/sales-order/constants/constants";
import data from "src/app/inventory/staticJSON/settings-column.json";
import { FinanceService } from "src/app/finance/finance.service";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { Severity, Status } from "src/app/inventory/constants/constants";
import { ICustomAtributes, IReceivePayment, IReceivePaymentCreditMemo, IReceivePaymentDetail, IReceivePaymentListModel, IReceivePaymentNote } from "./model/receive-payment.model";
import { INote } from "src/app/inventory/sales-order/models/note.model";
import { ModuleName, ReceivePaymentDialogType, UnderPay } from "./constants/constants";
import { SharedChannelService } from "src/app/modules/shared/services/channel.service";
import { AccountModuleId } from "../../constants/modules.constant";
import { ChannelN } from "../../models/channel.model";
import { AccountsTransactionType, TransactionNames } from "src/app/finance/constants/constants";
import { ImportserialService } from "../../services/importserial.service";
import { AccountServiceN } from "src/app/accounts-v2/services/account.services";
import { AccountFlatteningService } from "src/app/inventory/sales-order/services/account-flattening.service";
import { Currency } from "../../model/currency.model";
import { AccountLeadDataService } from "src/app/modules/shared/stores/accountLeadDataStore/accountLeadData.service";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { ListService } from "src/app/configurations/inventory/custom/list/list.service";
import { uploadFiles, validateFiles } from "src/app/shared/upload-files";
import { ProductsService } from "src/app/inventory/products/products.service";
import { IPostingPeriodDetails } from "../posting-period-selector/models/posting-period.model";

@Component({
    selector: "app-receive-payments",
    templateUrl: "./receive-payments.component.html",
    styleUrls: ["./receive-payments.component.scss"],
})
export class ReceivePaymentsComponent implements OnInit, OnChanges, OnDestroy {
    @Input() displayInvoiceReceive;
    @Input() selectedInvoicing;
    @Input() type;
    @Input() accountChannels;
    @Input() receivedPaymentId;
    @Input() channelName;
    @Input() selectedAccChannel;
    @Output() invoiceReceiveEventEmitter = new EventEmitter();

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    fieldTypes = CustomAttributeFieldType;
    receivePaymentsForm: FormGroup;
    allAccountsDD = [];
    accountInfo;
    salesReceiptsTemplate:any;
    customFields = {
        misc_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };
    /** Custom Fields */
    allCustomFields: any[] = [];
    customAtributes :ICustomAtributes = {
        other1_item: [],
        other2_item: [],
        other3_item: [],
        labels_misc: [],
        labels_message: [],
    };
    miscItem1: any[] = [] ;
    miscItem2: any[] = [] ;
    miscItem3: any[] =  [] ;
    applyValidation: boolean = false;
    isPaymentReceiptsList : boolean = false;
    invoiceRecievedPayments : any ;
    allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"]; // For the attachment files
    invoiceCols = [];
    accountAddressInfo;
    displayAccountAddress = false;
    selectedAccountAddress;
    recInvoiceDate: Date;
    amountTotal = 0;
    amountDueTotal = 0;
    minDate1: Date = new Date(1988, 0, 1); 
    maxDate1: Date = new Date(2050, 11, 31);
    lockAmount = false;
    errNumerMsg = false;
    amountAppliedTotal = 0;
    writeOffAmountTotal = 0;
    maxApplied = 0;
    selectedCredits = [];
    showCreditColumn = false;
    creditAppliedTotal = 0;
    errCreditMsg = false;
    remainingMsg = false;
    remainingCredit = 0;
    remainingReceivedPayments = 0;
    receivedAmount = 0;
    displayCreditSelect = false;
    minimumDate = this.app._showDateTimeWithZone(new Date());
    maxDate = this.app._showDateTimeWithZone(new Date());
    displayWriteOff = false;
    selectedUnderPay;
    availCredit = 0;
    allFinancialAccounts = [];
    allClass = [];
    selectedFinancialAccount;
    selectedClass;
    errPendingMsg = false;
    triangle = "fa fa-caret-down";
    InvoiceTB: IReceivePaymentListModel[] = [];
    selectedRecInvoice: IReceivePaymentListModel;
    availableCredits = [];
    invoicingDetails;
    credits = [];
    isDisabled = false;
    allPaymentMethods;
    isCreditTotalBalanceValid = false;
    statementMessege : string = "";
    
    soChannel = SOChannel;
    moduleName = ModuleName;
    dialogType = ReceivePaymentDialogType;
    underpay = UnderPay;

    // fraction digits
    fractionDigits: number = 0;
    baseCurrency : any
    currencies = [];
    defaultCurrency: Currency;
    netDueAmount: any;
    // posting period
    currentPostingPeriodInfo: IPostingPeriodDetails;
    updatedPostingPeriodInfo: IPostingPeriodDetails;
    isAllowPostingPeriod: boolean = false;
    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId: number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule: string = "";

    constructor(
        public app: AppMainComponent,
        private fb: FormBuilder,
        private salesOrderService: SalesOrderService,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private financeService: FinanceService,
        private financeUtilityService: FinanceUtilityService,
        private titlecasePipe: TitleCasePipe,
        private paymentMethodService: PaymentmethodService,
        private confirmationService: ConfirmationService,
        private sharedChannelService: SharedChannelService,
        private importService: ImportserialService,
        private accountServiceN: AccountServiceN,
        private accountFlatteningService: AccountFlatteningService,
        private accountDataService: AccountLeadDataService,
        private utilityService: UtilityService,
        private datepipe: DatePipe,
        private customfieldService: ListService,
        private productsService: ProductsService
        
        
    ) { }

    ngOnInit(): void {
        this.getIsettings();
        this.getOrderData('Orders Type')
        this.getFractionDigits();
        this.getBaseCurrency();
        this.initForm();
        this.loadPaymentMethod();
        this.loadCurrencies();
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.displayInvoiceReceive && changes.displayInvoiceReceive.currentValue) {
            this.displayInvoiceReceive = changes.displayInvoiceReceive.currentValue;
            this.initForm();
            this.initData();
            
        }
        if (changes.type && changes.type.currentValue) {
            this.type = changes.type.currentValue;
            this.initForm();
            if (this.type == this.dialogType.SinglePayment) {
                this.getInvoicingDetailsById();
            } else if (this.type == this.dialogType.ViewPaymentDetails || this.type == this.dialogType.Edit) {
                this.getReceivedPaymentsById();
            }else{
                this.loadCustomFields('')
            }
        }
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    initData() {
        this.availableCredits = [];
        this.InvoiceTB = [];
        this.amountTotal = 0;
        this.amountDueTotal = 0;
        this.amountAppliedTotal = 0;
        this.creditAppliedTotal = 0;
        this.showCreditColumn = false;
        this.remainingCredit = 0;
        this.remainingReceivedPayments = 0;
        this.errNumerMsg = false;
        this.errCreditMsg = false;
        this.remainingMsg = false;
        this.isDisabled = false;
        this.errPendingMsg = false;
        this.isCreditTotalBalanceValid = false;
    }

    initForm() {
        const channel = this.accountChannels?.find((ac) => ac.id == this.selectedAccChannel?.id);
        this.receivePaymentsForm = this.fb.group({
            id: [0],
            accountChannel: [this.type == this.dialogType.MultiPayment ? channel : this.accountChannels?.find((ac) => ac.isDefault == true) ],
            account: [""],
            paymentMethod: [null, Validators.required],
            recInvoiceDate: [this.app._showDateTimeWithZone(new Date())],
            referenceNumber: [""],
            memo: [""],
            amountPay: [0],
            availCredit: [0],
        });
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }

    getInvoicingDetailsById() {
        this.appMainService.isShowSpinner("loadInvDetails");
        this.invoicingDetails = null;
        this.salesOrderService.getInvoiceDetailsById(this.selectedInvoicing.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe({
                next: res => {
                    this.invoicingDetails = res;
                    this.loadCustomFields('')
                    this.appMainService.isHideSpinner("loadInvDetails");
                    this.accountInfo = this.invoicingDetails?.account;
                    if(this.accountInfo){
                        this.accountInfo["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-"+ this.accountInfo?.['businessName'];
                    }
                    this.receivePaymentsForm.patchValue({
                        ...this.invoicingDetails,
                        account: this.accountInfo,
                        accountChannel: this.accountChannels?.find((ac) => ac.id == this.invoicingDetails?.account?.typeId),
                    });
                    const invoice: IReceivePaymentListModel = {
                        id: this.invoicingDetails.id,
                        invoiceId: this.invoicingDetails.id,
                        dueDate: this.invoicingDetails.invoiceDueDate ? this.app._showDateTimeWithZone(this.invoicingDetails.invoiceDueDate) : "",
                        invoiceNo: this.invoicingDetails.number,
                        invoiceAmount: this.invoicingDetails.netAmount,
                        accountId: this.invoicingDetails.accountId,
                        exchangeRate: this.invoicingDetails.exchangeRate,
                        currencyCode: this.invoicingDetails.currencyCode,
                        amountDue: this.invoicingDetails.dueAmount,
                        paidAmount : this.invoicingDetails.appliedAmount ?? 0,
                        actualDueAmount: this.invoicingDetails.dueAmount,
                        credit: 0,
                        amountApplied: 0,
                        contactId: this.invoicingDetails.contactId,
                        isCreditApplied: false,
                        isReceivedPaymentApplied: false,
                        txnId: 0,
                        txnNumber: "",
                        transactionType: 0,
                        salesOrderId: 0,
                        salesOrderNumber: "",
                        netDueAmount: this.invoicingDetails?.netDueAmount ?? 0,
                        invoicePendingAmount: 0,
                        receivedPaymentId: 0
                    };
                    this.InvoiceTB = [invoice];
                    this.selectedRecInvoice = this.InvoiceTB[0];

                    this.amountTotal = 0;
                    this.amountDueTotal = 0;
                    this.InvoiceTB.forEach((d) => {
                        this.amountTotal += Number(d.invoiceAmount);
                        this.amountDueTotal += Number(d.amountDue);
                    });
                    this.getCreditMemo(this.invoicingDetails.accountId);
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadInvDetails");
                    this.showErrorMessage();
                }
			});
    }
/** End Custom Fields */
    getReceivedPaymentsById(){
        this.amountTotal = 0;
        this.amountDueTotal = 0;
        this.amountAppliedTotal = 0;
        this.writeOffAmountTotal = 0;
        this.appMainService.isShowSpinner("loadInvoice");
        this.sharedChannelService.getChannels(AccountModuleId)     
            .pipe(
                takeUntil(this.ngUnsubscribe$),         
                switchMap((res: ChannelN[]) => {             
                    this.accountChannels = res;             
                    return this.salesOrderService.getReceivedPaymentsById(this.receivedPaymentId);         
                }),         
                takeUntil(this.ngUnsubscribe$))     
                .subscribe({         
                    next: res => {
                        this.currentPostingPeriodInfo = {
                            postingDate: res?.postingDate,
                            postingMonth: res?.postingMonth,
                            postingYear: res?.postingYear,
                        };
                        this.setReceivedPaymentDetailsData(res);
                        if(this.type == this.dialogType.Edit){
                            this.editReceivedPayment()
                        }
                        this.appMainService.isHideSpinner("loadInvoice");
					},       
                    error: (error: any) => {    
                        this.appMainService.isHideSpinner("loadInvoice");         
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Error occurred...",
                        });       
                    }     
                });
    }
    setReceivedPaymentDetailsData(res){
        this.invoicingDetails = res;
        this.loadCustomFields('edit');
        this.accountInfo = this.invoicingDetails?.account;
        if(this.accountInfo){
            this.accountInfo["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-"+ this.accountInfo?.['businessName'];
        }
        const currentYear = this.app._showDateTimeWithZone(this.invoicingDetails?.receivedPaymentDate).getFullYear();
        this.minDate1 = new Date(currentYear, 0, 1);
        this.maxDate1 = new Date(currentYear, 11, 31);
        this.receivePaymentsForm.patchValue({
            ...this.invoicingDetails,
            account: this.accountInfo,
            amountPay: this.invoicingDetails?.totalReceivedAmount ?? 0,
            accountChannel: this.accountChannels?.find((ac) => ac.id == this.invoicingDetails?.account?.typeId),
            memo: this.invoicingDetails?.receivedPaymentNote && this.invoicingDetails?.receivedPaymentNote.length > 0
                ? this.invoicingDetails?.receivedPaymentNote[this.invoicingDetails?.receivedPaymentNote.length - 1].note.comment
                : "",
            recInvoiceDate: this.invoicingDetails?.receivedPaymentDate ? this.app._showDateTimeWithZone(this.invoicingDetails?.receivedPaymentDate) : this.app._showDateTimeWithZone(new Date()),
        });
        this.receivePaymentsForm.disable();
        this.setCreditMemos();
        this.selectedUnderPay = this.invoicingDetails?.isWriteOff ? this.underpay[1] : this.underpay[0];
        
        this.InvoiceTB = this.invoicingDetails?.receivedPaymentDetail?.map((r) => {
            const obj = {
                ...r,
                invoiceId: r?.transactionType == AccountsTransactionType.JournalEntry ? r.txnId : r.invoiceId,
                invoiceNo: r?.transactionType == AccountsTransactionType.JournalEntry ? r.txnNumber : this.channelName === this.soChannel.SALES_ORDER ? r.salesOrderNumber : r.invoiceNumber,
                invoiceAmount: r.invoiceAmount ?? 0,
                exchangeRate: r.invoice?.exchangeRate ,
                currencyCode: r.invoice?.currencyCode ,
                amountDue: r.amountDue ?? 0,
                actualDueAmount: r.amountDue ?? 0,
                due: r.amountDue ?? 0,
                paidAmount : r.totalPaidAmount ?? 0,
                credit: r.appliedCredit ?? 0,
                amountApplied: r.invoiceReceivedAmount ?? 0,
                contactId: "",
                isCreditApplied: r.appliedCredit && r.appliedCredit > 0,
                isReceivedPaymentApplied: true,
                dueDate: r.dueDate ? this.app._showDateTimeWithZone(r.dueDate) : "",
                netDueAmount: r.amountDue ?? 0
            };

            this.amountTotal += Number(obj.invoiceAmount);
            this.amountDueTotal += Number(obj.amountDue);
            this.amountAppliedTotal += Number(obj.amountApplied);
            this.writeOffAmountTotal += Number(obj.writeOffAmount);
            return obj;
        });
        this.selectedRecInvoice = this.InvoiceTB[0];
    }
    
    setCreditMemos(){
        if(this.invoicingDetails?.receivedPaymentCreditMemo && this.invoicingDetails?.receivedPaymentCreditMemo.length > 0){
            this.showCreditColumn = true;
            let sum = 0;
            this.availableCredits = (this.invoicingDetails?.receivedPaymentCreditMemo || []).map((element) => {
                const obj = {
                    ...element,
                    number: element?.creditMemoNumber ?? "",
                    createdDate: this.app._showDateTimeWithZone(element.createdDate),
                    createdBy: element.createdByUser,
                    amount: element.appliedCreditAmount,
                };
                sum += Number(obj.amount);
                return obj;
            });
            this.creditAppliedTotal = sum;
            this.receivePaymentsForm.controls["availCredit"].setValue(sum);
            this.selectedCredits = this.availableCredits;
            this.availCredit = this.selectedCredits?.reduce((sum, d) => sum + Number(d.amount), 0);
        }
    }

    getAllClass() {
        this.salesOrderService.getAllClasses("0", "0", "", "isactive", "name", true, "allclass").then((res) => {
            let { classes, headers } = res;
            classes = classes == null ? [] : classes;
            headers = headers == null ? [] : headers;
            this.allClass = classes?.map(element => ({
                id: element.id,
                name: element.name,
            }));
        });
    }
    
    isClosingStatementDate(event : string) {
        this.statementMessege = event ;
    }

    loadFinancialAccounts() {
        this.appMainService.isShowSpinner("loadaccounts");
        this.financeService.getAllFinancialAccounts()
          .subscribe({
            next: (accounts) => {
                let acc = JSON.parse(JSON.stringify(accounts)); 
                this.allFinancialAccounts = this.financeUtilityService.prepareFinancialAccountsData(acc);
                this.appMainService.isHideSpinner("loadaccounts");
            },
            error: (error) => {
                this.appMainService.isHideSpinner("loadaccounts");
                this.showErrorMessage();
            }
        });
    }

    getCreditMemo(id) {
        this.salesOrderService.getCreditMemoByAccount(id, null, 0, 0, true)
            .pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe({
                next: res => {
                    this.availableCredits = [];
                    const data = res?.map(element => ({
                        ...element,
                        status: element.creditMemoStatus,
                        createdDate: this.app._showDateTimeWithZone(element.creditMemoDate),
                        createdBy: element.createdByUser,
                        amount: element.pendingCreditAmount,
                    }));
                    this.availableCredits = data;
                    const sum = data.reduce((total, d) => total + Number(d.amount), 0);
                    this.receivePaymentsForm.controls["availCredit"].setValue(sum);
                },
                error: () => {
                    this.showErrorMessage();
                }
			});
    }

    getInvoicesByAccount(id) {
        this.salesOrderService.getInvoicesByAccount(id).subscribe((res) => {
            this.amountTotal = 0;
            this.amountDueTotal = 0;
            this.InvoiceTB = [];
            this.InvoiceTB = res?.map(element => ({
                id: element.invoiceId && element.invoiceId > 0 ? element.invoiceId : element?.txnId && element?.txnId > 0 ? element?.txnId : 0,
                invoiceId: element?.transactionType == AccountsTransactionType.JournalEntry ? element.txnId : element.invoiceId,
                dueDate: element.invoiceDueDate ? this.app._showDateTimeWithZone(element.invoiceDueDate) : "",
                invoiceNo: element?.transactionType == AccountsTransactionType.JournalEntry ? element.txnNumber : element.invoiceNumber,
                invoiceAmount: element.totalAmount,
                exchangeRate: element.exchangeRate,
                currencyCode: element.currencyCode,
                amountDue: element.dueAmount,
                actualDueAmount: element.dueAmount,
                credit: element.creditAmount,
                amountApplied: 0,
                paidAmount : element?.paidAmount ,
                contactId: element.contactId,
                isCreditApplied: false,
                isReceivedPaymentApplied: false,
                txnId: element?.txnId ?? 0,
                txnNumber: element?.txnNumber ?? "",
                transactionType: element?.transactionType ?? 0
            }));
            this.selectedRecInvoice = this.InvoiceTB[0];
            this.InvoiceTB?.forEach(d => {
                this.amountTotal += Number(d.invoiceAmount);
                this.amountDueTotal += Number(d.amountDue);
            });
        });
    }

    prepareApplicableCreditsList(element: IReceivePaymentListModel){
        let creditsList = [];
        let creditAmount = Number(element.credit);
        const sData = _.cloneDeep(this.credits);

        /** sort by the closest value */
        sData.sort((a, b) => {
            return Math.abs(creditAmount - a.amount) - Math.abs(creditAmount - b.amount);
        });
        
        /** calculate how much amount is applied from each credit */
        sData.forEach((e) => {
            if (creditAmount != 0 && creditAmount >= e.amount) {
                const f = _.cloneDeep(e);
                creditsList.push({...f, invoiceId: element.invoiceId});
            } else if (creditAmount != 0 && e.amount >= creditAmount) {
                const d = _.cloneDeep(e);
                d.amount = creditAmount;
                creditsList.push({...d, invoiceId: element.invoiceId});
            }
            if (creditAmount && creditAmount >= e.amount) {
                creditAmount = creditAmount - e.amount;
                e.amount = 0;
            } else {
                e.amount = e.amount - creditAmount;
                creditAmount = 0;
            }
        });
        this.credits = _.cloneDeep(sData);
        return creditsList;
    }

    prepareReceivePaymentCreditMemoData(creditsList: any[]): IReceivePaymentCreditMemo[] {
        const receivedPaymentCreditMemos: IReceivePaymentCreditMemo[] = (creditsList || []).map(credit => ({
            id: this.type == this.dialogType.Edit ? credit.id : 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            receivePaymentId: 0,
            creditMemoId: credit?.type?.toLowerCase() == "payment" || credit?.type?.toLowerCase() == "journalentry" || credit?.type?.toLowerCase() == "journal entry" ? 0 : credit?.id ?? 0,
            invoiceId: credit.invoiceId,
            appliedCreditAmount: credit.amount,
            statusId: Status.Active,
            salesOrderId: 0,
            overPaymentId: credit?.type?.toLowerCase() == "payment" ? credit?.id : 0,
            txnId: this.type == this.dialogType.Edit ? credit?.txnId ?? 0 : credit?.typeId != 3 && credit?.typeId != 2 ? credit?.id : 0,
        }));
        return receivedPaymentCreditMemos;
    }

    prepareReceivePaymentNote(): IReceivePaymentNote[] {
        let invoiceNotes: IReceivePaymentNote[] = [];
        if (this.receivePaymentsForm.controls["memo"].value && this.receivePaymentsForm.controls["memo"].value != "") {
            const invoiceNote: IReceivePaymentNote = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                receivedPaymentId: 0,
                userId: this.app.user.userId,
                noteId: 0,
                note: this.prepareNote(this.receivePaymentsForm.controls["memo"].value),
            }
            invoiceNotes.push(invoiceNote);
        }
        return invoiceNotes;
    }

    prepareNote(comment: string): INote {
        const note: INote = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            comment: comment,
            isImportant: true,
            organizationId: this.app.companyId,
            description: "",
            statusId: Status.Active,
            status: null,
            isValid: true,
            validFromDate: this.app._saveDateTimeWithZone(new Date()),
            validToDate: this.app._saveDateTimeWithZone(new Date()),
            noteComments: null,
            noteAttachments: null,
            createdByName: "",
        }
        return note
    }

    save() {
        if (this.checkCustomValidation()) {
            this.applyValidation = true;
            return this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please fill all required fields."
            });
        } 
        const customAttributeList = this.prepareCustomFieldsForSave();
        const receivedPaymentDetails : IReceivePaymentDetail[] = [];
        const creditsList = [];
        let totalAppliedAmount = 0;
        this.credits = _.cloneDeep(this.selectedCredits);
        this.InvoiceTB.forEach((element) => {
            const receivePaymentDetail: IReceivePaymentDetail = {
                id: this.type == this.dialogType.Edit ? element.id : 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                receivedPaymentId: this.type == this.dialogType.Edit ? element.receivedPaymentId : 0,
                invoiceId: element?.transactionType != AccountsTransactionType.JournalEntry ? element.invoiceId : 0,
                invoiceAmount: this.type == this.dialogType.Edit ? element.invoiceAmount :  Number(element.actualDueAmount),
                invoiceReceivedAmount: Number(element.amountApplied),
                contactId: element.contactId,
                invoicePendingAmount: this.selectedUnderPay?.code != "write off" ? Number(element.amountDue) : 0,
                statusId: Status.Active,
                appliedCredit: Number(element.credit),
                writeOffAmount: this.selectedUnderPay?.code == "write off" ? Number(element.amountDue) : 0,
                txnId: element?.transactionType == AccountsTransactionType.JournalEntry ? element.invoiceId : 0,
                txnNumber: element?.transactionType == AccountsTransactionType.JournalEntry ? element.txnNumber : "",
                salesOrderId: element.salesOrderId ?? 0,
                salesOrderNumber: element.salesOrderNumber ?? "",
                
            };
            if (element.credit + element.amountApplied > 0) {
                totalAppliedAmount += element.amountApplied;
                receivedPaymentDetails.push(receivePaymentDetail);
            }
            creditsList.push(...this.prepareApplicableCreditsList(element));
        });
        
        const receivePayment: IReceivePayment = {
            id: this.type == this.dialogType.Edit ? this.invoicingDetails.id : 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            number: this.invoicingDetails?.number ?? "",
            description: "",
            organizationId: this.app.companyId,
            accountId: this.receivePaymentsForm.controls["account"].value.id,
            paymentMethodId: this.receivePaymentsForm.controls["paymentMethod"].value?.id ?? 0,
            paymentTermId: 0,
            receivedPaymentDate: this.app._saveDateTimeWithZone(this.receivePaymentsForm.controls["recInvoiceDate"].value),
            totalReceivedAmount: this.receivePaymentsForm?.controls?.amountPay?.value ?? 0, 
            memo: this.receivePaymentsForm.controls["memo"].value,
            currencyUnitId: 0,
            discountId: 0,
            discountTypeId: 0,
            discount: 0,
            referenceNumber: this.receivePaymentsForm.controls["referenceNumber"].value,
            statusId: Status.Active,
            isValid: true,
            validFromDate: this.app._saveDateTimeWithZone(new Date()),
            validToDate: this.app._saveDateTimeWithZone(new Date()),
            receivedPaymentNote: this.prepareReceivePaymentNote(),
            receivedPaymentAudit: null,
            financialAccountId: this.selectedFinancialAccount?.value?.id || 0,
            classId: this.selectedClass ? this.selectedClass.id : 0,
            isWriteOff: this.selectedUnderPay?.code == "write off",
            receivedPaymentDetail: receivedPaymentDetails,
            receivedPaymentCreditMemo: this.prepareReceivePaymentCreditMemoData(creditsList),
            customAttributeValues: (this.type != this.dialogType.ViewPaymentDetails && this.type != this.dialogType.Edit) ? this.setCustomAttributes(customAttributeList) : this.setExistingCustomAttributes(customAttributeList),
            businessName: this.receivePaymentsForm.controls["account"].value?.businessName,
            channelId: this.receivePaymentsForm.controls.accountChannel.value?.id,
            overPaymentAmount: this.remainingReceivedPayments,
            pendingOverPaymentAmount: this.remainingReceivedPayments,
            paymentTypeId: 1,
            isTransaction: true,
            postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : (this.type == this.dialogType.Edit ? this.invoicingDetails.postingDate : this.app._saveDateTimeWithZone(this.receivePaymentsForm.controls["recInvoiceDate"].value)),
            postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : (this.type == this.dialogType.Edit ? this.invoicingDetails.postingMonth : new Date(this.receivePaymentsForm.controls["recInvoiceDate"].value).getMonth() + 1),
            postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : (this.type == this.dialogType.Edit ? this.invoicingDetails.postingYear : new Date(this.receivePaymentsForm.controls["recInvoiceDate"].value).getFullYear())

        };
        this.isDisabled = true;

        if(this.type && this.type == ReceivePaymentDialogType.Edit){
            this.updateReceivePayment(receivePayment);
        } else {
            this.addNewReceivePayment(receivePayment);
        }
    }
    addNewReceivePayment(receivePayment){
        this.appMainService.isShowSpinner("loadInvoice");
        this.salesOrderService
            .createReceivedPAyment(receivePayment)
            .then(() => {
                this.appMainService.isHideSpinner("loadInvoice");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Payment Received successfully...",
                });
                this.clearValues();
                this.invoiceReceiveEventEmitter.emit(false);
            })
            .catch((e) => {
                this.isDisabled = false;
                this.appMainService.isHideSpinner("loadInvoice");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }
    updateReceivePayment(receivePayment){
        this.appMainService.isShowSpinner("loadInvoice");
        this.salesOrderService
            .updateReceivedPayment(receivePayment)
            .then(() => {
                this.appMainService.isHideSpinner("loadInvoice");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Payment Received successfully...",
                });
                this.clearValues();
                this.invoiceReceiveEventEmitter.emit(false);
            })
            .catch((e) => {
                this.isDisabled = false;
                this.appMainService.isHideSpinner("loadInvoice");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }

    /** Edit Received Payment */

    editReceivedPayment(){
        this.type = ReceivePaymentDialogType.Edit;
        this.amountTotal = 0;
        this.amountDueTotal = 0;
        this.amountAppliedTotal = 0;
        this.InvoiceTB = this.InvoiceTB?.map((r) => {
            const obj = {
                ...r,
                actualDueAmount: r.amountApplied + r.netDueAmount + r.credit,
                // amountDue: (r.amountApplied + r.netDueAmount + r.credit) - r.amountApplied,
            };
            this.amountTotal += Number(obj.invoiceAmount);
            this.amountDueTotal += Number(obj.amountDue);
            this.amountAppliedTotal += Number(obj.amountApplied);
            // this.writeOffAmountTotal += Number(obj.writeOffAmount);
            return obj;
        });
        this.selectedRecInvoice = this.InvoiceTB[0];
        this.receivePaymentsForm.controls["recInvoiceDate"].setValue(this.app._showDateTimeWithZone(new Date()));    
        this.receivePaymentsForm.enable();

    }

    clearValues() {
        this.receivePaymentsForm.controls["account"].setValue("");
        this.receivePaymentsForm.controls["availCredit"].setValue(0);
        this.availCredit = 0;
        this.availableCredits = [];
        this.InvoiceTB = [];
        this.selectedRecInvoice = null;
        this.amountTotal = 0;
        this.amountDueTotal = 0;
        this.selectedCredits = [];
    }

    selectAccount(c) {
        this.getCreditMemo(c.id);
        this.getInvoicesByAccount(c.id);
        this.getPaymentMethods(c.id);
    }

    getPaymentMethods(accountId: number){
        this.salesOrderService.getPaymentMethod(accountId).subscribe({
            next: (res) => {
                const defaultMethods = res.find((d) => d.isDefault);
                if(defaultMethods){
                    this.receivePaymentsForm.controls["paymentMethod"].setValue(defaultMethods?.paymentMethod);
                }
            }
        });
    }

    filterAccount(event) {
        let query = event.query;
        const typeId = this.receivePaymentsForm.controls['accountChannel'].value?.id;
        query = event.query;
        this.accountServiceN.getAccountsByNameWithHierarchy(typeId, query).subscribe((res: any) => {
            if (res?.length > 0) {
                this.allAccountsDD = this.accountFlatteningService.flattenAccounts(res);
            }
        });
    }

    onRowSelectAccountAddress(e) {
        this.displayAccountAddress = false;
        this.accountAddressInfo = JSON.parse(
            JSON.stringify(this.selectedAccountAddress)
        );
    }

    confirmVoid(){
        this.confirmationService.confirm({
            message: "Do you want to void?",
            header: "Void Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.voidReceivedPayment();
            },
            reject: () => { },
        });
    }
    voidReceivedPayment(){
        this.appMainService.isShowSpinner("voidreceivedPayment");
        this.salesOrderService
            .voidReceivedPayment(this.receivedPaymentId)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: res => {
                    this.appMainService.isHideSpinner("voidreceivedPayment");
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Voided successfully...",
                    });
                    this.closeDialog(true);
                },
                error: () => {
                    this.appMainService.isHideSpinner("voidreceivedPayment");
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred...' });
                }
            });
    }

    sumAmountApplied() {
        let sum = 0;
        let amountPay = Number(this.receivePaymentsForm.controls["amountPay"].value);
        this.amountDueTotal = 0;
        if (this.InvoiceTB && this.InvoiceTB.length > 0) {
            this.InvoiceTB.forEach((d) => {
                if (!d.amountApplied) {
                    d.amountApplied = 0;
                }
                sum += Number(d.amountApplied);
                d.amountDue = d.actualDueAmount - (d.amountApplied + d.credit);
                this.amountDueTotal += Number(d.amountDue);
            });
            this.amountAppliedTotal = Number(sum);
            if(this.receivePaymentsForm.controls["amountPay"].value < this.amountAppliedTotal){
                this.receivePaymentsForm.controls["amountPay"].setValue(this.amountAppliedTotal);
                amountPay = this.amountAppliedTotal;
            }
            if (sum > amountPay) {
                this.errNumerMsg = true;
                this.errPendingMsg = false;
            } else if (sum < amountPay) {
                this.errPendingMsg = true;
                this.errNumerMsg = false;
                this.remainingReceivedPayments = amountPay - sum;
            } else {
                this.remainingReceivedPayments = amountPay - sum;
                this.errNumerMsg = false;
                this.errPendingMsg = false;
            }
        }
    }

    onBlurCalulateAmountApplied(c) {
        this.remainingReceivedPayments -= c.amountApplied;
        this.sumAmountApplied();
    }
    onFocusCalulateAmountApplied(c) {
        this.maxApplied = 0;
        if (c.amountApplied <= 0 && this.remainingReceivedPayments > 0) {
            if (c.credit < c.actualDueAmount) {
                const diff = c.actualDueAmount - c.credit;
                c.amountApplied = diff >= this.remainingReceivedPayments ? this.remainingReceivedPayments : diff;
            } else if (c.credit > c.actualDueAmount) {
                const diff = c.credit - c.actualDueAmount;
                c.amountApplied = diff >= this.remainingReceivedPayments ? this.remainingReceivedPayments : diff;
            } else if (c.credit == c.actualDueAmount) {
                c.amountApplied = 0;
            }
        }
        this.maxApplied = Number(c.actualDueAmount) - Number(c.credit);
    }

    onRowSelect(e) {
        if(this.type == this.dialogType.ViewPaymentDetails){
            return;
        }
        
        const c = e?.data;
        this.maxApplied = 0;
        if (this.remainingCredit && !c.credit) {
            if (c.amountApplied <= c.actualDueAmount) {
                const diff = c.actualDueAmount - c.amountApplied;
                c.credit = diff >= this.remainingCredit ? this.remainingCredit : diff;
            } else if (c.amountApplied > c.actualDueAmount) {
                const diff = c.amountApplied - c.actualDueAmount;
                c.credit = diff >= this.remainingCredit ? this.remainingCredit : diff;
            }
            this.remainingCredit -= c.credit;
            this.creditAppliedTotal += c.credit;
        }
    
        if (c.amountApplied <= 0 && this.remainingReceivedPayments > 0) {
            if (c.credit <= c.actualDueAmount) {
                const diff = c.actualDueAmount - c.credit;
                c.amountApplied = diff >= this.remainingReceivedPayments ? this.remainingReceivedPayments : diff;
            } else if (c.credit > c.actualDueAmount) {
                const diff = c.credit - c.actualDueAmount;
                c.amountApplied = diff >= this.remainingReceivedPayments ? this.remainingReceivedPayments : diff;
            }
            c.isReceivedPaymentApplied = true;
            this.remainingReceivedPayments -= c.amountApplied;
        }
        this.maxApplied = Number(c.actualDueAmount) - Number(c.credit);
        this.sumAmountApplied();
    }

    onBlurSumCreditApplied(c) {
        this.remainingCredit -= c.credit;
        let t = 0;
        const creditApplied = Number(this.receivePaymentsForm.controls["availCredit"].value);
        this.InvoiceTB.forEach((d) => {
            if (d.credit) {
                t += Number(d.credit);
            } else {
                d.credit = 0;
            }
        });
        if (t > creditApplied) {
            this.errCreditMsg = true;
        } else {
            this.errCreditMsg = false;
            this.creditAppliedTotal = t;
            if (this.creditAppliedTotal < creditApplied) {
                this.remainingMsg = true;
                this.remainingCredit = creditApplied - this.creditAppliedTotal;
            } else {
                this.remainingMsg = false;
            }
        }
        c.amountDue = c.actualDueAmount - (c.amountApplied + c.credit);
        this.sumAmountApplied();
    }

    onFocusCalulateCreditToBeApplied(c) {
        if (this.remainingCredit && !c.credit) {
            if (c.amountApplied < c.actualDueAmount) {
                const diff = c.actualDueAmount - c.amountApplied;
                c.credit =
                    diff >= this.remainingCredit ? this.remainingCredit : diff;
            } else if (c.amountApplied > c.actualDueAmount) {
                const diff = c.amountApplied - c.actualDueAmount;
                c.credit =
                    diff >= this.remainingCredit ? this.remainingCredit : diff;
            } else if (c.amountApplied == c.actualDueAmount) {
                c.credit = 0;
            }
        }
    }

    applySelectedCredit() {
        this.showCreditColumn = true;
        const availCredit = Number(this.receivePaymentsForm.controls["availCredit"].value);
        this.creditAppliedTotal = 0;
        for (let c of this.InvoiceTB) {
            if (c.id == this.selectedRecInvoice.id) {
                c.credit = 0;
                if (availCredit && !c.credit) {
                    if (c.amountApplied <= c.actualDueAmount) {
                        const diff = c.actualDueAmount - c.amountApplied;
                        c.credit = diff >= availCredit ? availCredit : diff;
                    } else if (c.amountApplied > c.actualDueAmount) {
                        const diff = c.amountApplied - c.actualDueAmount;
                        c.credit = diff >= availCredit ? availCredit : diff;
                    }

                    if (c.credit) {
                        this.remainingCredit = availCredit - c.credit;
                        this.creditAppliedTotal += c.credit;
                    } else {
                        this.remainingCredit = availCredit;
                    }
                }
                c.amountDue = c.actualDueAmount - (c.amountApplied + c.credit);
            }
        }
        this.remainingCredit = availCredit - this.creditAppliedTotal;
        this.remainingMsg = this.remainingCredit ? true : false;
        this.displayCreditSelect = false;
        this.sumAmountApplied();
        this.isCreditTotalValid();
    }

    viewAllCredit() {
        if (this.selectedRecInvoice == null) {
            this.selectedRecInvoice = this.InvoiceTB[0];
        }
        this.displayCreditSelect = true;
    }

    calTotalCredit(c) {
        this.receivePaymentsForm.controls["availCredit"].setValue(0);
        let sum = 0;
        this.selectedCredits.forEach((d) => {
            sum += Number(d.amount);
        });
        this.availCredit = sum;
        this.receivePaymentsForm.controls["availCredit"].setValue(sum);
    }

    isCreditTotalValid(){
        this.isCreditTotalBalanceValid =  (Number(this.creditAppliedTotal) + Number(this.remainingCredit)) == Number(this.receivePaymentsForm.controls["availCredit"].value);
    }
    closeCreditSelectionModal(){
        this.displayCreditSelect = false;
        const availCredit = Number(this.receivePaymentsForm.controls["availCredit"].value);
        if(availCredit == 0){
            for (let c of this.InvoiceTB) {
                c.credit = 0;
            }
            this.creditAppliedTotal = 0;
            this.remainingCredit = 0;
            this.sumAmountApplied();
        }
        this.isCreditTotalValid();
    }
    resetReceivedPaymentValue(amountPay){
        this.selectedRecInvoice.amountApplied = Number(amountPay);
        // this.selectedRecInvoice.actualDueAmount = Number(this.selectedRecInvoice.invoiceAmount);
        this.selectedRecInvoice.amountDue = this.selectedRecInvoice.actualDueAmount - this.selectedRecInvoice.amountApplied;
    }

    autoSumAmount() {
        const amountPay = Number(this.receivePaymentsForm.controls["amountPay"].value);
        this.remainingReceivedPayments = amountPay;
        this.receivedAmount = amountPay;
        if (amountPay) {
            if(this.type && this.type == ReceivePaymentDialogType.Edit){
                this.resetReceivedPaymentValue(amountPay);
            }

            const c = this.selectedRecInvoice;
            if (c?.credit <= c?.actualDueAmount) {
                const diff = c.actualDueAmount - c.credit;
                c.amountApplied = diff >= amountPay ? amountPay : diff;
                c.amountDue = c.actualDueAmount - (c.amountApplied + c.credit);
            } else if (c?.credit > c?.actualDueAmount) {
                const diff = c.credit - c.actualDueAmount;
                c.amountApplied = diff >= amountPay ? amountPay : diff;
                c.amountDue = c.actualDueAmount - (c.amountApplied + c.credit);
            }
            this.receivePaymentsForm.get("paymentMethod").setValidators([Validators.required]);
            this.receivePaymentsForm.get("paymentMethod").updateValueAndValidity();
        } else {
            this.receivePaymentsForm.get("paymentMethod").clearValidators();
            this.receivePaymentsForm.get("paymentMethod").updateValueAndValidity();
        }
        this.sumAmountApplied();
    }

    underpayOption() {
        if (this.selectedUnderPay?.code?.toLowerCase() == "write off") {
            this.getAllClass();
            this.loadFinancialAccounts();
            this.displayWriteOff = true;
        }
    }

    getYearRange() {
        return `${new Date().getFullYear() - 100} : ${new Date().getFullYear()}`;
    }

    closeDialog(isSave) {
        this.clearValues();
        this.invoiceReceiveEventEmitter.emit(isSave);
    }

    loadPaymentMethod() {
        this.appMainService.isShowSpinner('loadPaymentMethod');
        this.paymentMethodService.getPaymentMrthodList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: res => {
                    this.appMainService.isHideSpinner('loadPaymentMethod');
                    this.allPaymentMethods = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner('loadPaymentMethod');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred...' });
                }
            });
    }

    showErrorMessage(){
        this.messageService.add({
            severity: Severity.Error,
            summary: this.titlecasePipe.transform(Severity.Error),
            detail: "Error occurred ...",
        });
    }
    loadCurrencies(): void {
            this.accountDataService
              .loadCurrencies()
              .pipe(
                map((currencies) => {
                  this.currencies = currencies?.filter((el) => el.isActive) || [];
                  this.currencies = this.currencies.map((el) => {
                    return {
                      id: el.id,
                      name: el.name + ' - ' + el.code,
                    };
                  });
        
                  this.defaultCurrency = currencies
                    ?.filter((el) => el.isDefault)
                    .map((el) => {
                      return {
                        id: el.id,
                        name: el.name + ' - ' + el.code,
                      };
                    })[0];
                }),
                catchError(() => [])
              )
              .subscribe();
          }
    getBaseCurrency() {
        this.importService.getOrgCurrency().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((value) => {
            if (value) {
                this.baseCurrency = value?.find((cr) => cr.isBaseCurrency);
            }
        });
    }

        /** Custom fields start*/
    prepareCustomFieldsForSave(): any {
        this.customAtributes.labels_misc = JSON.parse(JSON.stringify([...this.miscItem1, ...this.miscItem2, ...this.miscItem3]));
        const customattributeList: any[] = [];
        const allCustomFieldsGroups = [
            this.customAtributes?.other1_item,
            this.customAtributes?.other2_item,
            this.customAtributes?.other3_item,
            this.customAtributes?.labels_message,
            this.customAtributes?.labels_misc
        ];
        allCustomFieldsGroups.forEach(group => {
            group?.forEach(element => {
                const controlName = element?.formControl?.name;
                const hasFile = (controlName === "FileUpload" || controlName === "Picture") && element?.customUploadedFiles?.length > 0;
                if (hasFile || element?.value) {
                    customattributeList.push(element);
                }
            });
        });
        const customFields = customattributeList.reduce((acc, item) => {
            const sectionName = item.section?.name;
            if (!acc[sectionName]) {
                acc[sectionName] = [];
            }
            acc[sectionName].push(item);
            return acc;
        }, {});
        return this.utilityService.getCustomAttributesForAddEdit(customFields);
    }
    getCustomAttributesForAddEdit(customFields) {
        const customattributeList = [];
        const cf = customFields;
        Object.keys(cf).forEach((key) => {
            const dataArr = cf[key];
            if (dataArr && dataArr.length > 0) {
                dataArr?.forEach((element) => {
                    if ((element?.formControl?.name == "FileUpload" || element?.formControl?.name == "Picture") && element?.customUploadedFiles?.length > 0) {
                        customattributeList.push(element);
                    } else if (element.value) {
                        customattributeList.push(element);
                    }
                });
            }
        });
        return customattributeList;
    }

    loadCustomFields(action: string) {
        const allModules = this.app.preLoadedObjects;
        const ordersModule = allModules?.find((obj) => obj?.name === "Orders");
        if (!ordersModule?.id) {
            return;
        }

        this.appMainService.isShowSpinner("loadCustomFields");
        this.appMainService.isShowSpinner("getSalesReceiptsTemplate");
        forkJoin({
            customFields: from(this.customfieldService.getAllCustomFields(ordersModule.id)),
            orderTemplates: this.salesOrderService.getAllOrdersChannel("Orders Template"),
        }).subscribe({
            next: ({ customFields, orderTemplates }) => {
                this.allCustomFields = customFields;
                const configJSON = orderTemplates?.configurationDetails?.[0]?.configJSONValue;
                const parsedConfig = configJSON ? JSON.parse(configJSON) : [];
                this.salesReceiptsTemplate = parsedConfig?.find((t) => t?.templateName === "SalesReceipt_template");
                this.getCustomFieldList(action);
            },
            error: (err) => {
                console.error("Error in loadCustomFields", err);
            },
            complete: () => {
                this.appMainService.isHideSpinner("loadCustomFields");
                this.appMainService.isHideSpinner("getSalesReceiptsTemplate");
                this.appMainService.isHideSpinner("loadAllTemplates");
            },
        });
    }

    getCustomFieldList(action?) {
        this.customAtributes.other1_item = [];
        this.customAtributes.other2_item = [];
        this.customAtributes.other3_item = [];
        this.customAtributes.labels_misc = [];
        this.customAtributes.labels_message = [];

        const sectionMap = {
            labels_salesreceipt_other1: "other1_item",
            labels_salesreceipt_other2: "other2_item",
            labels_salesreceipt_other3: "other3_item",
            labels_misc: "labels_misc",
            labels_message: "labels_message",
        };

        const handleInit = (fld, templateSection, targetListName) => {
            const check = templateSection?.find((el) => el.code === fld?.name && el.sectionId === fld.section?.id)?.isChecked;
            fld.isChecked = check;
            if (!check) return;

            switch (fld.formControl?.name) {
                case "FileUpload":
                case "Picture":
                    fld.customUploadedFiles = [];
                    break;
                case "DatePicker":
                    fld.value = this.datepipe.transform(new Date(), "MM/dd/yyyy");
                    break;
                case "ToggleButton":
                    fld.value = false;
                    break;
            }

            fld.labelname = templateSection?.find((el) => el.code === fld?.name && el.sectionId === fld.section?.id)?.labelname;

            this.customAtributes[targetListName].push(fld);
            this.customAtributes[targetListName] = this.customAtributes[targetListName].map((obj) => {
                const newObj = { ...obj };
                if ("value" in newObj) delete newObj.value;
                return newObj;
            });
        };

        this.allCustomFields?.forEach((fld) => {
            if (fld.isDelete && fld.section?.name && fld.section?.code in sectionMap) {
                const templateSection = this.salesReceiptsTemplate?.[fld.section?.code];
                const targetListName = sectionMap[fld.section?.code];
                handleInit(fld, templateSection, targetListName);
            }
        });

        if (action === "edit") {
            const populateValue = (list) => {
                list.forEach((element) => {
                    const filtered = this.invoicingDetails.customAttributeValues?.find((c) => c.customAttributeId === element.id);
                    const control = filtered?.customAttribute?.formControl?.name;

                    if (!filtered || !control) return;

                    switch (control) {
                        case "InputBox":
                        case "Decimal":
                        case "Number":
                            element.value = filtered.value;
                            break;
                        case "FileUpload":
                        case "Picture":
                            element.customUploadedFiles = [...(filtered.customeAttachement || [])];
                            break;
                        case "DatePicker":
                            element.value = this.datepipe.transform(filtered.value, "MM/dd/yyyy");
                            break;
                        case "Rating":
                            element.value = filtered.ratingId;
                            break;
                        case "ToggleButton":
                            element.value = filtered.toggle;
                            break;
                        case "DropDownList":
                            element.value = filtered.values;
                            break;
                        case "RadioButton":
                            element.value = filtered.values?.name;
                            break;
                        case "CheckBox":
                        case "MultipleDropDownList":
                            element.value = [...(filtered.multipleValues?.map((el) => (control === "CheckBox" ? el?.name : el)) || [])];
                            break;
                    }
                });
            };

            populateValue(this.customAtributes.other1_item);
            populateValue(this.customAtributes.other2_item);
            populateValue(this.customAtributes.other3_item);
            populateValue(this.customAtributes.labels_misc);
            populateValue(this.customAtributes.labels_message);
        }

        const misc = this.customAtributes.labels_misc || [];
        const miscItem1 = [],
            miscItem2 = [],
            miscItem3 = [];

        misc.forEach((item, index) => {
            if (index % 3 === 0) miscItem1.push(item);
            else if (index % 3 === 1) miscItem2.push(item);
            else miscItem3.push(item);
        });

        this.miscItem1 = miscItem1;
        this.miscItem2 = miscItem2;
        this.miscItem3 = miscItem3;

    }

    isNumberKey(evt) {
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    onCustomUpload(files: File[], field, instance) {
        if (typeof Worker !== undefined) {
            for (let file of files) {
                let errors: any[] = [];
                errors = validateFiles(file, 4, this.allowedExtensions);
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error.fileName + ": " + error.error,
                        });
                    }
                } else {
                    uploadFiles(file, ({ name, content, size, extension }) => {
                        let attachment = {
                            name: name,
                            content: content,
                            extension: extension,
                            sizeInBytes: size,
                        };
                        field.customUploadedFiles.push(attachment);
                    });
                }
            }
            instance.clear();
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
            });
        }
    }

    deleteFile(field, index) {
        field?.customUploadedFiles.splice(index, 1);
    }

    checkRequired(name, cf_list) {
        return cf_list?.find((el) => el?.name === name)?.isRequired || false;
    }

    setTogleValue(field, event) {
        field.value = event.checked;
    }
    checkCustomValidation() {
        const requiredFields: any[] = [];

        this.customAtributes?.other1_item?.forEach((element) => {
            if (element.isRequired) {
                requiredFields.push(element);
            }
        });
        this.customAtributes?.other2_item?.forEach((element) => {
            if (element.isRequired) {
                requiredFields.push(element);
            }
        });
        this.customAtributes?.other3_item?.forEach((element) => {
            if (element.isRequired) {
                requiredFields.push(element);
            }
        });

        const nullValue: any[] = [];
        requiredFields?.forEach((element) => {
            if ((element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture") && element.customUploadedFiles.length == 0) {
                nullValue.push(element);
            }
        });
        requiredFields?.forEach((element) => {
            if (element.formControl?.name != "FileUpload" && element.formControl?.name != "Picture" && element.formControl?.name != "ToggleButton" && (element.value == null || element.value == "")) {
                nullValue.push(element);
            }
        });

        if (nullValue.length > 0) {
            return true;
        } else {
            return false;
        }
    }
    setExistingCustomAttributes(value) {
        const custom = [];
        if (value.length > 0) {
            value?.forEach((element) => {
                const customEach = {
                    id: this.invoicingDetails?.customAttributeValues?.filter((custom) => custom.customAttributeId == element.id)[0] ? this.invoicingDetails.customAttributeValues?.filter((custom) => custom.customAttributeId == element.id)[0]?.id : 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.app.preLoadedObjects?.find((obj) => obj?.name == "Receive Payment")?.id,
                    objectValue: this.invoicingDetails.id,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value: element.formControl?.name == "InputBox" || element.formControl?.name == "Number" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" ? element.value : null,
                    statusId: 1,
                    status: null,
                    values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                    multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                    ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                    toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                    customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }
    setCustomAttributes(value) {
        const custom = [];
        if (value.length > 0) {
            value?.forEach((element) => {
                const customEach = {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.app.preLoadedObjects.find((obj) => obj?.name == "Receive Payment").id,
                    objectValue: 0,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value: element.formControl?.name == "InputBox" || element.formControl?.name == "Number" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" ? element.value : null,
                    statusId: 1,
                    status: null,
                    values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                    multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                    ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                    toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                    customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }
    modifyCustumAttributes(data) {
        if (data.pickListValues) {
            data.pickListValues = JSON.stringify(data.pickListValues);
        }
        return data;
    }
    setCheckBoxValue(value) {
        const checkBox = [];
        value?.forEach((element) => {
            const val = { name: element };
            checkBox.push(val);
        });
        return checkBox;
    }
    /** Custom fields end*/
    /** paid amount list start*/
    getInvoiceRecievedPaymentsById(id) {

        this.invoiceRecievedPayments = [];
        this.netDueAmount = null;
        this.appMainService.isShowSpinner("loadInvoice");
        this.salesOrderService.getInvoiceReceivedPaymentById(id, true).subscribe((res) => {
            const d = [];
            if (res && res.length > 0) {
                res.forEach((r) => {
                    const obj = {
                        ...r,
                        id: r.receivedPaymentId,
                        invoiceId: r.invoiceId,
                        statusName: r.status,
                        createdDate: this.app._showDateTimeWithZone(r.createdDate),
                        paidAmt: r.paidAmount,
                        repname: r.repName,
                        dueAmt: r.dueAmount,
                        totalAmt: r.totalAmount,

                    };
                    d.push(obj);
                });
            }
            this.invoiceRecievedPayments = d;
            this.netDueAmount = this.invoiceRecievedPayments[0]?.netDueAmount ?? null;
            this.appMainService.isHideSpinner("loadInvoice");
        });
    }

    getOrderData(name: string) {
        this.appMainService.isShowSpinner("loadsettings");
        forkJoin({
            channels: this.salesOrderService.getAllOrdersChannel(name),
            configs: this.productsService.getProductConfigurations("order"),
        }).subscribe(({ channels, configs }) => {
            const config = JSON.parse(channels?.configurationDetails[0]?.configJSONValue || "[]");
            const settingConfig = configs?.find((config) => config.name === "Order Column Settings");
            let invoiceCols;
            if (settingConfig?.configurationDetails?.length) {
                const settingColumns = JSON.parse(settingConfig.configurationDetails[0].configJSONValue || "[]");
                const invoicingChannel = config?.find((channel) => channel.name === "Invoicing");
                const invoiceSetting = settingColumns?.find((setting) => setting.typeId === invoicingChannel);
                invoiceCols = invoiceSetting?.ListDetailCols;
            }
            this.invoiceCols = invoiceCols || data.invoice.details_Columns;
            
            this.appMainService.isHideSpinner("loadsettings");
        });
    }

    openTransactionList(product) {
        this.isPaymentReceiptsList  = true;
        this.getInvoiceRecievedPaymentsById(product?.invoiceId);
    }
    /** paid amount list end*/
        // posting period
    getIsettings() {
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find((obj) => obj.code === "posting")?.enabled ?? false;
    }
    onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
        this.updatedPostingPeriodInfo = postingInfo;
    }
    showInventoryDialog(rowData) {
        this.inventoryOverviewRefId = rowData?.invoiceId || 0;
        this.inventoryOverviewRefNumber = rowData?.number;
        this.inventoryOverviewModule = TransactionNames.Invoice;
        this.displayInventoryOverview = true
      }

      closeViewPopup() {
        this.displayInventoryOverview = false;
      }
}
